import { lazy } from 'react';
import { IRouteProps } from 'src/modules';

export const route = '/how-to-get-guaranteed-allocation';

const WhiteListRoute: IRouteProps = {
    path: route,
    exact: true,
    component: lazy(() => import('src/modules/LandingPage/LandingPage')),
    name: 'LandingPage',
};

export default WhiteListRoute;
